webpackJsonp([1],{

/***/ "0wWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Haftungsausschluss")]),_c('h4',[_vm._v("Rechtliche Hinweise")]),_c('p',[_vm._v("Alle Informationen auf dieser Website dienen dem Zweck der allgemeinen Orientierung. Sie sind keine Rechtsberatung. Ich habe die Informationen sorgfältig geprüft und bemühe mich sorgfältig um Aktualität. Rechtsprechung und Gesetze ändern sich oft. Ich kann daher keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen übernehmen. Haftungsansprüche gegen mich, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen.")]),_c('p',[_vm._v("Sämtliche möglichen Angebote sind freibleibend und unverbindlich. Ich behalte es mir ausdrücklich vor, Teile der Seiten oder die gesamte Website ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen. Wenn ich mit Hyperlinks auf Internetangebote Dritter verweise, vermittele ich lediglich den Zugang zu ihnen, mache mir aber deren Inhalt ausdrücklich nicht zu Eigen. Ich erkläre ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf diesen Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten Seiten habe ich keinen Einfluss. Deshalb distanziere ich mich ausdrücklich von allen Inhalten aller verlinkten Seiten, die nach der Linksetzung verändert wurden.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2FnK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Baurecht',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "4BaZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  }
});

/***/ }),

/***/ "4cpP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Haftungsausschluss_vue__ = __webpack_require__("QKNc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9bccdd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Haftungsausschluss_vue__ = __webpack_require__("0wWV");
function injectStyle (ssrContext) {
  __webpack_require__("fCpY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b9bccdd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Haftungsausschluss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b9bccdd0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Haftungsausschluss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6RIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datenschutz_vue__ = __webpack_require__("t/nE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121ce0de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Datenschutz_vue__ = __webpack_require__("rypL");
function injectStyle (ssrContext) {
  __webpack_require__("CKWC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-121ce0de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datenschutz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_121ce0de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Datenschutz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6W+T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8nU7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Alvd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Zivilrecht',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "BGlB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bvkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeueAdressen_vue__ = __webpack_require__("za8s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4daefc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NeueAdressen_vue__ = __webpack_require__("PU0m");
function injectStyle (ssrContext) {
  __webpack_require__("KmHZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc4daefc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NeueAdressen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4daefc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_NeueAdressen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CKWC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CX2x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zivilrecht_vue__ = __webpack_require__("Alvd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c1bc52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Zivilrecht_vue__ = __webpack_require__("wR/L");
function injectStyle (ssrContext) {
  __webpack_require__("8nU7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75c1bc52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Zivilrecht_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75c1bc52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Zivilrecht_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CgsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impressum_vue__ = __webpack_require__("YJs7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5efb38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Impressum_vue__ = __webpack_require__("w8lP");
function injectStyle (ssrContext) {
  __webpack_require__("fAmC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e5efb38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Impressum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e5efb38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Impressum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DBbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Honorare")]),_c('h4',[_vm._v("Gute Arbeit kostet Geld")]),_c('p',[_vm._v("Die Transparenz der Gebühren ist mir ein besonderes Anliegen."),_c('br'),_vm._v("Die gesetzlich vorgesehene Abrechnung der Rechtsanwaltshonorare in Deutschland ist im bundeseinheitlichen "),_c('b',[_vm._v("Rechtsanwaltsvergütungsgesetz")]),_vm._v(" ("),_c('b',[_vm._v("RVG")]),_vm._v(") geregelt. \nDie danach zu berechnenden Gebühren richten sich hauptsächlich nach der Höhe des Gegenstandswertes, das heißt nach dem wirtschaftlichen Interesses des Mandanten (zum Beispiel der Forderungshöhe). \nSodann nach den so genannten Rahmengebühren, die im Vergütungsverzeichnis als Anlage zum RVG aufgelistet sind. Es werden die Gebühren für die verschiedenen möglichen anwaltlichen Tätigkeiten wie Beratung, vorgerichtliche Vertretung, Einreichen der Klage, Verhandlungstermin, ggbfls. \nVergleich und anderes berechnet. Bei sehr einfachen Fällen mit hohen Streitwerten oder umgekehrt bei wirtschaftlich zwar unbedeutenden, aber dennoch rechtlich anspruchsvollen und besonders zeitintensiven Streitigkeiten ist das RVG als Preisgrundlage der anwaltlichen Leistungen unbefriedigend und teils unangemessen. \nNach Auffassung des Gesetzgebers soll dies durch die regelmäßige Mischung von Mandaten mit unterschiedlichen Streitwerten ausgeglichen werden. Es bedeutet indessen letztlich eine Subventionierung der komplizierten, anspruchsvollen und zeitintensiven Mandate durch die einfachen Fälle mit vergleichsweise hohen Streitwerten."),_c('br'),_vm._v("Es können hiervon abweichend oder auch zusätzlich Vereinbarungen über die Vergütung getroffen werden, die allerdings die gesetzlichen Gebühren nicht unterschreiten dürfen. ")]),_c('h4',[_vm._v("Stundenhonorare")]),_c('p',[_vm._v("Ich vereinbare für meine anwaltlichen Dienstleistungen regelmäßig konkret projektbezogene Honorare, meist nach Stunden berechnet oder lege eine angemessene Pauschalierung zu Grunde. \nDabei kalkuliere ich einen Stundensatz von netto 225 Euro bis 275 Euro, je nach Bedeutung, wirtschaftlichem Wert (und Haftungsrisiko) des Mandates sowie unter Beachtung des voraussichtlichen Zeitaufwandes und der juristischen Schwierigkeit. \nEine zeitnahe Abrechnung gewährleistet dabei die Transparenz und Prüfbarkeit meiner Tätigkeit sowie der entstehenden Kosten. Ich bin gesetzlich gehalten darauf hinzuweisen, dass in gerichtlichen Verfahren Vergütungsvereinbarungen nicht getroffen werden dürfen, die zu einer Unterschreitung der gesetzlichen Gebühren führen würde (§ 49b BRAO).")]),_c('h4',[_vm._v("Pauschale Vergütungsvereinbarung – Beratungsverträge")]),_c('p',[_vm._v("Vor allem für langfristige Mandatsbeziehungen mit regelmäßigem und auch häufig kurzfristigem Beratungsbedarf von beispielsweise Unternehmen empfiehlt sich der Abschluss eines Beratungsvertrages mit der Vereinbarung einer monatlichen Grundpauschale, die je nach Bedarf ein Basishonorar von mindestens 550 EUR vorsieht.\nDie Honorare bei Vergütungsvereinbarungen rechne ich dabei monatlich ab, sodass für den Mandanten ebenfalls die Transparenz und Kostenkontrolle sichergestellt ist.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "E4NY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Architektenrecht',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Ezqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanzleiprofil_vue__ = __webpack_require__("eQ1Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b43938_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Kanzleiprofil_vue__ = __webpack_require__("L4Mp");
function injectStyle (ssrContext) {
  __webpack_require__("6W+T")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76b43938"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kanzleiprofil_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76b43938_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Kanzleiprofil_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Her8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ir72":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Kontakt")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KSa3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startseite_vue__ = __webpack_require__("upN6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635fc907_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Startseite_vue__ = __webpack_require__("hsPV");
function injectStyle (ssrContext) {
  __webpack_require__("sYFj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-635fc907"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startseite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_635fc907_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Startseite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KmHZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L4Mp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Kanzleiprofil")]),_c('p',[_vm._v("Rechtsanwalt Schommer begann seine Tätigkeit im Jahre 1988 bei den Rechtsanwälten Ulrich Behr, Ulrike Lachmann und Robert Neixler in Berlin Charlottenburg und wurde 1993 Partner der Sozietät BLN & Partner GbR (Rechtsanwälte * Notare * Wirtschaftsprüfer) bis zu deren Auflösung Ende 2018. \nEr war dort vornehmlich im Bereich des zivilen Bau- und Architektenrecht tätig und betreute mehr als 27 Jahre zahlreiche mittelständische Bauunternehmungen sowie Architektenbüros. \nSeit 2006 ist Rechtsanwalt Schommer Fachanwalt für Bau- und Architektenrecht.")]),_c('p',[_vm._v("Das Kanzleiprofil wurde und wird auch weiterhin nahezu ausschließlich geprägt durch das zivile Baurecht und Architektenrecht. \nBeratung und Interessenvertretung auf hohem fachlichem Niveau ist sein vornehmstes Anliegen.\nWeiteres Leitmotiv seiner Anwaltstätigkeit ist der enge Kontakt und das Vertrauensverhältnis zu den Mandanten.")]),_c('p',[_vm._v("Mit vielen der Mandanten, insbesondere den weiterhin betreuten mittelständischen Bauunternehmen und Architektenbüros, verbinden Rechtsanwalt Schommer langfristige, teils schon mehr als 2 Jahrzehnte dauernde Beratungsverträge.\nAuch die sehr lange Zusammenarbeit mit und Mandatierung durch Architekten – Haftpflichtversicherungen bestätigen seine Reputation und erweiterten kontinuierlich seinen Erfahrungshorizont.")]),_c('p',[_vm._v("Sein Bestreben ist es, unnötiges Prozessieren durch kompetente Vorfeldberatung möglichst zu vermeiden.\nUnumgängliche gerichtliche Auseinandersetzung scheut er dennoch nicht, denn Herr Rechtsanwalt Schommer verfügt über vielfältige Erfahrungen und eine beachtliche Erfolgsquote als Prozessanwalt. ")]),_c('p',[_vm._v("Seine fachliche Kompetenz ist darüber hinaus bereits seit 2006 durch die Fachanwaltschaft für Bau-und Architektenrecht, regelmäßige jährliche Fortbildungsveranstaltungen und zusätzlich durch Publikationen in Fachzeitschriften, durch Referententätigkeiten und Qualifizierungsveranstaltungen, u.a. in Bauunternehmen zur Mitarbeiter-/Bauleiterschulungen ausgewiesen.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5f2534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("UWXs");
function injectStyle (ssrContext) {
  __webpack_require__("ln2E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c5f2534_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__("Tqaz");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// Vue plugins
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);

// Vue config
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OAii":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OLjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kontakt_vue__ = __webpack_require__("aB9U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8154c37a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Kontakt_vue__ = __webpack_require__("Ir72");
function injectStyle (ssrContext) {
  __webpack_require__("yMhX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8154c37a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kontakt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8154c37a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Kontakt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PPnX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person_lachmann.e027b72.jpg";

/***/ }),

/***/ "PU0m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Extern container"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"Extern-content"},[_c('div',{staticClass:"Extern-content-wrapper"},[_vm._m(2),_vm._m(3),_vm._m(4),_c('router-link',{staticClass:"Extern-content-item",attrs:{"to":{ name: 'Startseite' },"tag":"a"}},[_c('div',{staticClass:"Extern-content-details"},[_c('div',{staticClass:"Extern-content-image-wrapper"},[_c('img',{attrs:{"src":__webpack_require__("ZaXU")}})]),_c('div',{staticClass:"Extern-content-description-wrapper"},[_c('h4',[_vm._v("Rechtsanwalt Christoph Schommer")]),_c('p',{staticClass:"Extern-content-description"},[_vm._v("Albestraße 21, 12159 Berlin"),_c('br'),_vm._v(" Telefon: (030) 74 75 10 10\n"),_c('br'),_vm._v(" Telefax: (030) 74 75 10 44\n"),_c('br'),_vm._v(" E-Mail: "),_c('a',{attrs:{"href":"mailto:schommer@bln-partner.de"}},[_vm._v("schommer@bln-partner.de")]),_vm._v(" "),_c('br'),_vm._v(" www.ra-schommer.de")])])])]),_vm._m(5),_vm._m(6)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Bln-head"},[_c('div',{staticClass:"Bln-head-img"},[_c('img',{attrs:{"src":__webpack_require__("RS69")}})]),_c('div',{staticClass:"Bln-head-hdline"},[_c('h2',[_vm._v("Behr Lachmann Neixler & Partner GbR ist zum Jahresende 2018 aufgelöst")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Extern-text"},[_c('p',[_vm._v("Sehr geehrte Mandantinnen und Mandanten,")]),_c('p',[_vm._v("auch Erfolgsgeschichten sind endlich.")]),_c('p',[_vm._v("Wir haben unsere berufliche Zusammenarbeit zum Ende des Jahres 2018 beendet, die Sozietät BLN & Partner GbR aufgelöst und den gemeinsamen Kanzleisitz in der Englerallee 19, 14195 Berlin aufgegeben.")]),_c('p',[_vm._v("Seit 01. Januar 2019 erreichen Sie uns unter folgenden Adressen und Kontaktdaten:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Extern-content-empty-item"},[_c('div',{staticClass:"Extern-content-details"},[_c('div',{staticClass:"Extern-content-image-wrapper"},[_c('img',{attrs:{"src":__webpack_require__("Xzq8")}})]),_c('div',{staticClass:"Extern-content-description-wrapper"},[_c('h4',[_vm._v("Rechtsanwalt, Notar und Wirtschaftsprüfer Ulrich Behr")]),_c('p',{staticClass:"Extern-content-description"},[_vm._v("c/o Buse Heberer Fromm PartG mbB,"),_c('br'),_vm._v(" Kurfürstendamm 237, 10719 Berlin\n"),_c('br'),_vm._v(" Telefon: (030) 327942 – 0\n"),_c('br'),_vm._v(" E-Mail: "),_c('a',{attrs:{"href":"mailto:behr@bln-partner.de"}},[_vm._v("behr@bln-partner.de")]),_vm._v(" und "),_c('a',{attrs:{"href":"mailto:wolter@bln-partner.de"}},[_vm._v("wolter@bln-partner.de")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Extern-content-empty-item"},[_c('div',{staticClass:"Extern-content-details"},[_c('div',{staticClass:"Extern-content-image-wrapper"},[_c('img',{attrs:{"src":__webpack_require__("PPnX")}})]),_c('div',{staticClass:"Extern-content-description-wrapper"},[_c('h4',[_vm._v("Rechtsanwältin und Notarin Ulrike Lachmann")]),_c('p',{staticClass:"Extern-content-description"},[_vm._v("hat ihre berufliche Tätigkeit beendet.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Extern-content-empty-item"},[_c('div',{staticClass:"Extern-content-details"},[_c('div',{staticClass:"Extern-content-image-wrapper"},[_c('img',{attrs:{"src":__webpack_require__("leX6")}})]),_c('div',{staticClass:"Extern-content-description-wrapper"},[_c('h4',[_vm._v("Rechtsanwalt und Notar Robert Neixler")]),_c('p',{staticClass:"Extern-content-description"},[_vm._v("hat seine berufliche Tätigkeit beendet.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"Extern-content-item",attrs:{"href":"https://www.gerchel-wolff.de","target":"_blank"}},[_c('div',{staticClass:"Extern-content-details"},[_c('div',{staticClass:"Extern-content-image-wrapper"},[_c('img',{attrs:{"src":__webpack_require__("bYD+")}})]),_c('div',{staticClass:"Extern-content-description-wrapper"},[_c('h4',[_vm._v("Rechtsanwalt Thomas Gerchel")]),_c('p',{staticClass:"Extern-content-description"},[_vm._v("Lützowstraße 33 – 36, 10785 Berlin"),_c('br'),_vm._v(" c/o Rechtsanwälte Wiese & Schlichting\n"),_c('br'),_vm._v(" Telefon: (030) 74 75 10 60\n"),_c('br'),_vm._v(" Telefax: (030) 74 75 10 44\n"),_c('br'),_vm._v(" E-Mail: "),_c('a',{attrs:{"href":"mailto:gerchel@bln-partner.de"}},[_vm._v("gerchel@bln-partner.de")]),_vm._v(" "),_c('br'),_c('a',{attrs:{"href":"https://www.gerchel-wolff.de","target":"_blank"}},[_vm._v("www.gerchel-wolff.de")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Extern-content-empty-item"},[_c('div',{staticClass:"Extern-content-details"},[_c('div',{staticClass:"Extern-content-image-wrapper"},[_c('img',{attrs:{"src":__webpack_require__("VMhb")}})]),_c('div',{staticClass:"Extern-content-description-wrapper"},[_c('h4',[_vm._v("Rechtsanwalt Axel Claußen")]),_c('p',{staticClass:"Extern-content-description"},[_vm._v("Lützowstraße 33 – 36, 10785 Berlin"),_c('br'),_vm._v(" c/o Rechtsanwälte Wiese & Schlichting\n"),_c('br'),_vm._v(" Telefon: (030) 590 09 09 0\n"),_c('br'),_vm._v(" Telefax: (030) 590 09 09 10\n"),_c('br'),_vm._v(" E-Mail: "),_c('a',{attrs:{"href":"mailto:a.claussen@outlook.com"}},[_vm._v("a.claussen@outlook.com")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QKNc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Haftungsausschluss'
});

/***/ }),

/***/ "QRIw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Architektenrecht_vue__ = __webpack_require__("E4NY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8d48d38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Architektenrecht_vue__ = __webpack_require__("WDQ3");
function injectStyle (ssrContext) {
  __webpack_require__("e1Tt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d8d48d38"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Architektenrecht_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d8d48d38_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Architektenrecht_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RS69":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "RhwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Header'
});

/***/ }),

/***/ "RjMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("RhwW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547eb220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("raLk");
function injectStyle (ssrContext) {
  __webpack_require__("BGlB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_547eb220_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UWXs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"PageContent"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VMhb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person_claussen.ce63b7b.jpg";

/***/ }),

/***/ "WDQ3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Architektenrecht")]),_c('h4',[_vm._v("Vertragsgestaltung")]),_c('p',[_vm._v("Ich entwerfe Verträge über Architektenleistungen für alle Arten von Bauvorhaben. Ich arbeite in Vorbereitung der Vertragsentwürfe die rechtlichen und wirtschaftlichen Interessen des Architekten oder der Bauherren heraus. Insbesondere der Beschreibung der vertraglich geschuldeten Leistungen des Architekten widme ich große Sorgfalt. Der einfache Hinweis auf das Leistungsbild in der HOAI birgt für beide Vertragsparteien Risiken und Unwägbarkeiten in der Vertragsabwicklung. Deshalb prüfe ich für jedes Bauvorhaben individuell, welcher Regelungsbedarf bei der Beschreibung der Architektenleistungen besteht. Den Bauherrn interessieren vor allem Vereinbarungen über Baukosten und Fristen, während der Architekt Haftungsausschlüsse und Urheberrechte geregelt wissen möchte. ")]),_c('h4',[_vm._v("Honorarrecht")]),_c('p',[_vm._v("Ich setze Honoraransprüche von Architekten gerichtlich durch. Die Erfahrung hat gezeigt, dass viele Architekten ohne anwaltlichen Beistand die hohen komplexen Anforderungen der Rechtsprechung an die Prüfbarkeit ihrer Honorarabrechnungen nicht zu erfüllen vermögen. Ich leite Sie bei der Erstellung einer prüfbaren Abrechnung an. Für komplexe Bauvorhaben erstelle ich die Honorarrechnungen mit ihnen gemeinsam. Sehr oft ist es dadurch gelungen, die in der HOAI dargebotenen Abrechnungsmöglichkeiten auszuschöpfen und höhere Honorare gerichtlich durchzusetzen, als vom Architekten bisher abgerechnet.")]),_c('p',[_vm._v("Diese Erfahrungen kann ich auch für den Bauherrn nutzbar machen, der sich einer Architektenhonorarforderung ausgesetzt sieht. Ich prüfe, ob er sich wirksam zur Zahlung eines Pauschalhonorars verpflichtet hat und ob der Architekt ihm eine prüfbare Rechnung unterbreitet hat. Nach der mittlerweile gefestigten Rechtsprechung des Bundesgerichtshofs dürfen Bauherrn allerdings die Prüfung der Honorarrechnungen nicht mehr auf die lange Bank schieben: Einwände gegen die Prüfbarkeit der Architektenhonorarschlussrechnung sind nur noch binnen zwei Monaten möglich.")]),_c('h4',[_vm._v("Architektenhaftung")]),_c('p',[_vm._v("Baubegleitend unterstütze ich den Bauherrn bei der Geltendmachung von Gewährleistungsansprüchen wegen Planungs- oder Bauleitungsmängeln. ")]),_c('p',[_vm._v("Ich arbeite seit vielen Jahren mit zwei großen Berufshaftpflichtversicherern zusammen, für die ich regelmäßig Architekten in gerichtlichen Beweisverfahren oder Haftungsprozessen gegen Schadensersatzansprüche der Bauherren vertrete.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X2y2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Honorare',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "Xzq8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person_behr.d7d808f.jpg";

/***/ }),

/***/ "YJs7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Impressum'
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Startseite__ = __webpack_require__("KSa3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_content_Baurecht__ = __webpack_require__("ZrhF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_content_Architektenrecht__ = __webpack_require__("QRIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_content_Zivilrecht__ = __webpack_require__("CX2x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_content_Kontakt__ = __webpack_require__("OLjN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_content_Impressum__ = __webpack_require__("CgsU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_content_Datenschutz__ = __webpack_require__("6RIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_content_Haftungsausschluss__ = __webpack_require__("4cpP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_content_Kanzleiprofil__ = __webpack_require__("Ezqs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_content_Honorare__ = __webpack_require__("oycR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_bln_content_NeueAdressen__ = __webpack_require__("Bvkd");



// components












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPos) {
    if (savedPos) return savedPos;
    if (to.hash) return { selector: to.hash };
    return { x: 0, y: 0 };
  },

  routes: [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Startseite__["a" /* default */],
    name: 'Startseite'
  }, {
    path: '/baurecht',
    component: __WEBPACK_IMPORTED_MODULE_3__components_content_Baurecht__["a" /* default */],
    name: 'Baurecht'
  }, {
    path: '/architektenrecht',
    component: __WEBPACK_IMPORTED_MODULE_4__components_content_Architektenrecht__["a" /* default */],
    name: 'Architektenrecht'
  }, {
    path: '/zivilrecht',
    component: __WEBPACK_IMPORTED_MODULE_5__components_content_Zivilrecht__["a" /* default */],
    name: 'Zivilrecht'
  }, {
    path: '/kontakt',
    component: __WEBPACK_IMPORTED_MODULE_6__components_content_Kontakt__["a" /* default */],
    name: 'Kontakt'
  }, {
    path: '/impressum',
    component: __WEBPACK_IMPORTED_MODULE_7__components_content_Impressum__["a" /* default */],
    name: 'Impressum'
  }, {
    path: '/datenschutz',
    component: __WEBPACK_IMPORTED_MODULE_8__components_content_Datenschutz__["a" /* default */],
    name: 'Datenschutz'
  }, {
    path: '/haftungsausschluss',
    component: __WEBPACK_IMPORTED_MODULE_9__components_content_Haftungsausschluss__["a" /* default */],
    name: 'Haftungsausschluss'
  }, {
    path: '/kanzleiprofil',
    component: __WEBPACK_IMPORTED_MODULE_10__components_content_Kanzleiprofil__["a" /* default */],
    name: 'Kanzleiprofil'
  }, {
    path: '/honorare',
    component: __WEBPACK_IMPORTED_MODULE_11__components_content_Honorare__["a" /* default */],
    name: 'Honorare'
  }, {
    path: '/bln',
    component: __WEBPACK_IMPORTED_MODULE_12__components_bln_content_NeueAdressen__["a" /* default */],
    name: 'NeueAdressen'
  }, { path: '*', redirect: { name: 'Startseite' } }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "ZaXU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person_schommer.374aeb5.jpg";

/***/ }),

/***/ "ZrhF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Baurecht_vue__ = __webpack_require__("2FnK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eea6c83_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Baurecht_vue__ = __webpack_require__("gb4O");
function injectStyle (ssrContext) {
  __webpack_require__("OAii")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eea6c83"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Baurecht_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eea6c83_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Baurecht_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Zwd2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/rechtsanwalt-christoph-schommer.374aeb5.jpg";

/***/ }),

/***/ "aB9U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Kontakt',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "bYD+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person_gerchel.2adccc5.jpg";

/***/ }),

/***/ "e1Tt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eQ1Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Kanzleiprofil',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "fAmC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fCpY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gb4O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Privates Baurecht")]),_c('p',[_vm._v("Das "),_c('b',[_vm._v("private oder zivile Baurecht")]),_vm._v(" betrifft die Rechtsbeziehungen der Baubeteiligten untereinander. Schwerpunkte sind die vertraglichen Beziehungen zwischen denjenigen, die ein Bauwerk oder eine Bauaufgabe in Auftrag geben (Auftraggeber/Bauherren) und den Beteiligten, welche das Bauwerk planen sowie ausführen (wie z. B. Architekten, Ingenieure, Bauunternehmen/Handwerker - ggf. auch untereinander).")]),_c('p',[_vm._v("Im Gegensatz zum öffentlichen Baurecht bieten die gesetzlichen Regelungen auch nach der Reform der baurechtlichen Vorschriften im BGB lediglich ein grobes Fundament und es steht den Beteiligten im Rahmen der Privatautonomie frei, durch vertragliche Abreden (bspw. Vereinbarung VOB/B) und Gestaltungen abweichende Regelungen zu treffen. Insbesondere bei größeren Bauvorhaben ist deshalb die juristische / anwaltliche Hilfestellung und Beratung bereits im Vorfeld unbedingt empfehlenswert und wichtig.")]),_c('p',[_vm._v("Juristischer Regelungsbedarf besteht vor allem in diesen Bereichen:")]),_c('br'),_c('ul',[_c('li',[_vm._v("Vertragsgestaltung")]),_c('li',[_vm._v("Gestaltung von Bauträgerverträgen")]),_c('li',[_vm._v("Projektbegleitende Rechtsberatung")]),_c('li',[_vm._v("Durchsetzung und Sicherung von Werklohnansprüchen")]),_c('li',[_vm._v("Abwehr unberechtigter Werklohnansprüche")]),_c('li',[_vm._v("Gewährleistungsrechte")])]),_c('h4',[_vm._v("Meine Leistungen – meine Kompetenz")]),_c('p',[_vm._v("Seit über 30 Jahren berate ich und vertrete Baubeteiligte im gesamten Immobilienrecht und als Schwerpunkt meiner Tätigkeit im zivilen Baurecht. Seit 2006 bin ich Fachanwalt für Bau- und Architektenrecht. Durch regelmäßige Fortbildung und ständigen Austausch mit Fachkollegen kann ich ein hohes Niveau an fachlicher und kompetenter wie auch zuverlässiger und zeitnaher Beratung und Betreuung bei der Abwicklung sowohl kleiner Bauvorhaben als auch komplexer Bauprojekte von der Planungsphase bis zur Fertigstellung bieten und garantieren. Dabei verfüge ich über Erfahrung in der täglichen Beratung und in der forensischen Praxis im Hochbau ebenso wie im Tief- und Straßenbau durch jahrzehntelange Betreuung und Vertretung eines im europäischen Straßenbau tätigen großen Bauunternehmen.")]),_c('p',[_vm._v("Wichtig ist mir nicht nur eine Risiko minimierende und Prozess vermeidende Vertragsgestaltung, wobei mir komplexe GÜ/GU- und Projektverträge genauso wie einfache Subunternehmerverträge vertraut sind, sondern ich berate und begleite Sie ebenso zuverlässig und gezielt in Verhandlungen während des Bauvorhabens und/oder bei sich anbahnenden Konflikten (= baubegleitende Rechtsberatung). Dies wird nicht zuletzt ergänzt durch meine Erfahrungen in zahlreichen (auch gerichtlichen) Schlichtungs- und Mediationsverfahren sowie auch als Schlichter.")]),_c('p',[_vm._v("Ist die angestrebte Einigung und schnelle Streitschlichtung nicht möglich, biete ich Ihnen als erfahrener Prozessanwalt selbstverständlich auch die bestmögliche prozessuale Durchsetzung Ihrer Ansprüche einschließlich der ggf. erforderlichen Realisierung im Zwangsvollstreckungsverfahren.")]),_c('p',[_vm._v("Ich achte besonders auf eine enge Zusammenarbeit mit den jeweiligen Ansprechpartnern der Mandanten und lege Wert darauf, dass die teilweise komplexen und technisch anspruchsvollen Sachverhalte der Baurechtsstreitigkeiten in meinen Schriftsätzen für das Gericht nicht nur technisch zutreffend, sondern auch sprachlich verständlich dargestellt und transportiert werden. Meine Erfahrung aus über 30 Jahren anwaltlicher Tätigkeit mit Schwerpunkt Baurecht gewährleistet, dass auch technisch anspruchsvolle Materie im juristischen Zusammenhang eindeutig und anschaulich wiedergegeben wird.")]),_c('h4',[_vm._v("Vertragsgestaltung")]),_c('p',[_vm._v("Ich prüfe und entwerfe Ihre Bauverträge. Ob ein komplexes Vertragswerk ausgearbeitet werden muss oder ein kurzer VOB-Werkvertrag ausreicht, in dem nur die wesentlichen Eckdaten wie Vergütung, Fristen, Vertragsstrafen, Skonti und Sicherheiten geregelt werden, entscheide ich mit Ihnen anhand des einzelnen Bauvorhabens. Nicht jedes Bauvorhaben bedarf eines komplexen Vertragsmanagements. In vielen Bereichen sind kurze Verträge für die Vertragsbeteiligten besser zu handhaben. Für komplexere Bauvorhaben entwerfe ich an die Anforderungen angepasste umfassende Vertragswerke.")]),_c('h4',[_vm._v("Baubegleitende Rechtsberatung")]),_c('p',[_vm._v("Während der Bauphase stellen sich bei vielen Bauvorhaben immer wieder ähnliche Rechtsprobleme: Der Bauherr ordnet die Ausführung geänderter oder zusätzlicher Leistungen an. Die Parteien streiten über die Auswirkungen auf den Vergütungsanspruch des Bauunternehmers. Es kommt zu Bauablaufstörungen wie Verzögerungen, Insolvenzen oder anderen Unwägbarkeiten. Die Parteien streiten in diesen Fällen über die Verwirkung der Vertragsstrafe, den Ersatz weiteren Verzugsschadens oder die Erstattung von Mehrkosten des Bauunternehmers.")]),_c('p',[_vm._v("Lassen sich diese Konflikte nicht einvernehmlich beilegen, denken die Parteien oft über eine Vertragsbeendigung nach. Deren Folgen sind meist gravierend, und zwar sowohl für den Bauherrn, der gegebenenfalls die entgehende Vergütung schuldet, aber auch und vor allem für den Bauunternehmer, der sich schadensersatzpflichtig macht, wenn er ohne rechtliche Absicherung den Bauvertrag kündigt und die Leistungen nicht zu Ende führt. Der Bauherr wird dann auf  Kosten des Kündigenden einen Drittunternehmer beauftragen und sämtliche Mehrkosten als Schadensersatz geltend machen. Diese Schritte sollten immer anwaltlich begleitet werden. Gegebenenfalls lassen sich auch Konflikte mit nicht beherrschbaren Risiken durch rechtzeitiges Einschalten und besonnenes sowie geschicktes Verhandeln vermeiden.")]),_c('h4',[_vm._v("Baumängel")]),_c('p',[_vm._v("Gewährleistungsansprüche wegen Baumängeln stellen ein zentrales Thema im praktischen Baurecht dar. Hier geht es um Fragen der Beweissicherung, etwa im gerichtlichen Beweisverfahren oder durch Beauftragung von Sachverständigen. Die Gewährleistungsansprüche des Bauherrn sind auf Nachbesserung, Einbehalte, Kostenvorschuss und Schadensersatz gerichtet. Der Bauunternehmer will seinerseits möglichst zeitnah den ungeschmälerten Werklohn erhalten. Hier suche ich mit Ihnen zusammen stets nach zeit- und kostensparenden Strategien.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hsPV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[_vm._m(0),_vm._m(1),_c('div',{staticClass:"container Home-content"},[_c('div',{staticClass:"Home-content-wrapper"},[_c('router-link',{staticClass:"Home-content-item",attrs:{"to":{ name: 'Baurecht' },"tag":"a"}},[_c('div',{staticClass:"Home-content-icon"},[_c('i',{staticClass:"fa fa-2x fa-home"})]),_c('h4',[_vm._v("Privates Baurecht")]),_c('p',{staticClass:"Home-content-description"},[_vm._v("Das "),_c('b',[_vm._v("private oder zivile Baurecht")]),_vm._v(" betrifft die Rechtsbeziehungen der Baubeteiligten untereinander.")])]),_c('router-link',{staticClass:"Home-content-item",attrs:{"to":{ name: 'Architektenrecht' },"tag":"a"}},[_c('div',{staticClass:"Home-content-icon"},[_c('i',{staticClass:"fa fa-2x fa-building"})]),_c('h4',[_vm._v("Architektenrecht")]),_c('p',{staticClass:"Home-content-description"},[_vm._v("Vertragsentwürfe über Architektenleistungen für alle Arten von Bauvorhaben.")])])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0"},[_c('div',{staticClass:"jumbotron Home-background"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"Home-headline"},[_vm._v("Christoph Schommer")]),_c('h3',{staticClass:"Home-subheadline"},[_vm._v("Rechtsanwalt")]),_c('h3',{staticClass:"Home-subheadline"},[_vm._v("Fachanwalt für Bau- und Architektenrecht")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid Profile"},[_c('div',{staticClass:"container Profile-wrapper"},[_c('div',{staticClass:"col-md-4 Profile-image"},[_c('img',{attrs:{"src":__webpack_require__("Zwd2")}})]),_c('div',{staticClass:"col-md-8 Profile-text"},[_c('p',[_vm._v("Rechtsanwalt Christoph Schommer wurde 1959 in Saarbrücken geboren und war von 1988 an und ab 1993 als Partner der Sozietät Behr Lachmann Neixler & Partner GbR tätig. Seit Januar 2006 ist er Fachanwalt für Bau- und Architektenrecht.")]),_c('p',[_vm._v("Nach Auflösung der BLN & Partner GbR zum 31.12.2018 war Rechtsanwalt Schommer als Einzelanwalt in einer Steglitzer Bürogemeinschaft weiterhin vornehmlich in Bau- und Architektenangelegenheiten tätig.")]),_c('p',[_vm._v("Seit 01.01.2023 übt er nunmehr seine Anwaltstätigkeit in einer neuen Bürogemeinschaft in der Albestraße 21, 12159 Berlin in enger Kooperation mit Rechtsanwalt Jae-Yoon Lee aus, der ihn auch entsprechend bei Abwesenheiten vertreten wird.")]),_c('p',[_vm._v("RA Schommer ist seit 1993 Mitglied der Arbeitsgemeinschaft für Baurecht und Immobilien "),_c('a',{attrs:{"href":"https://www.arge-baurecht.com/"}},[_vm._v("ARGE Baurecht")]),_vm._v(" im Deutschen Anwaltsverein.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hsuy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"Footer"},[_c('div',{staticClass:"container py-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md Footer-block"},[_c('h5',{staticClass:"Footer-headline"},[_vm._v("Christoph Schommer")]),_c('small',{staticClass:"d-block mb-3 text-muted"},[_vm._v("© "+_vm._s(_vm.year))])]),_vm._m(0),_c('div',{staticClass:"col-12 col-md Footer-block"},[_c('h5',{staticClass:"Footer-headline"},[_vm._v("Ressourcen")]),_c('ul',{staticClass:"text-small Footer-list"},[_c('li',[_c('router-link',{staticClass:"Footer-item",attrs:{"to":{ name: 'Impressum' },"tag":"a"}},[_vm._v("Impressum")])],1),_c('li',[_c('router-link',{staticClass:"Footer-item",attrs:{"to":{ name: 'Datenschutz' },"tag":"a"}},[_vm._v("Datenschutz")])],1),_c('li',[_c('router-link',{staticClass:"Footer-item",attrs:{"to":{ name: 'Haftungsausschluss' },"tag":"a"}},[_vm._v("Haftungsausschluss              ")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md Footer-block"},[_c('h5',{staticClass:"Footer-headline"},[_vm._v("Kontakt")]),_c('div',{staticClass:"text-small"},[_c('p',{staticClass:"Footer-item"},[_vm._v("Albestraße 21, 12159 Berlin"),_c('br'),_vm._v("Tel: 030 / 74 75 10-10"),_c('br'),_vm._v("Fax: 030 / 74 75 10-44"),_c('br'),_vm._v("Mail: schommer@bln-partner.de")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j4Uy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "leX6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/person_neixler.e89ef8f.jpg";

/***/ }),

/***/ "ln2E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oXpM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("4BaZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3d4e3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("hsuy");
function injectStyle (ssrContext) {
  __webpack_require__("j4Uy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e3d4e3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e3d4e3a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oycR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Honorare_vue__ = __webpack_require__("X2y2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b6fd2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Honorare_vue__ = __webpack_require__("DBbh");
function injectStyle (ssrContext) {
  __webpack_require__("Her8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53b6fd2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Honorare_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53b6fd2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_Honorare_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "raLk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"Header"},[_c('b-navbar',{staticClass:"Header-nav site-header sticky-top py-0 navbar-dark",attrs:{"toggleable":"lg"}},[_c('div',{staticClass:"container"},[_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_c('router-link',{staticClass:"Header-mobile",attrs:{"to":{ name: 'Startseite' },"tag":"b-navbar-brand"}},[_vm._v("Rechtsanwalt Christoph Schommer")]),_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":"is-nav"}},[_c('b-navbar-nav',{staticClass:"Header-list"},[_c('router-link',{staticClass:"Header-item Header-item",attrs:{"to":{ name: 'Startseite' },"tag":"b-nav-item","active-class":"active","exact":"exact"}},[_vm._v("Startseite")]),_c('router-link',{staticClass:"Header-item",attrs:{"to":{ name: 'Kanzleiprofil' },"tag":"b-nav-item","active-class":"active","exact":"exact"}},[_vm._v("Kanzleiprofil")]),_c('b-nav-item-dropdown',{staticClass:"Header-item",attrs:{"text":"Tätigkeitsfelder"}},[_c('router-link',{staticClass:"Header-dropdown-item",attrs:{"to":{ name: 'Baurecht' },"tag":"b-dropdown-item","active-class":"active","exact":"exact"}},[_vm._v("Privates Baurecht")]),_c('router-link',{staticClass:"Header-dropdown-item",attrs:{"to":{ name: 'Architektenrecht' },"tag":"b-dropdown-item","active-class":"active","exact":"exact"}},[_vm._v("Architektenrecht")]),_c('li',{staticClass:"Header-dropdown-item disabled",attrs:{"tag":"b-dropdown-item"}},[_c('a',{staticClass:"dropdown-item disabled",attrs:{"href":"#"}},[_vm._v("Zivilrecht")])])],1),_c('router-link',{staticClass:"Header-item",attrs:{"to":{ name: 'Honorare' },"tag":"b-nav-item","active-class":"active","exact":"exact"}},[_vm._v("Honorare")])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rypL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Datenschutz")]),_c('p',[_c('strong',[_vm._v("Datenschutzerklärung – Stand Mai 2018")])]),_c('p',[_vm._v("Im Folgenden informiere ich über die Erhebung personenbezogener Daten bei Ihnen als betroffene Person im Rahmen der Nutzung meiner Website. Personenbezogene Daten sind dabei alle Informationen, die sich auf eine identifizierte oder identifizierbare natürliche Person beziehen, wie etwa Name, Anschrift, Telefonnummer, Email-Adresse, Beruf, Bankverbindung etc. Unter der Verarbeitung von Daten versteht man insbesondere deren Erhebung, Speicherung, Verwendung und Übermittlung.")]),_c('p',[_vm._v("Verantwortliche Stelle gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung (DSGVO) ist: Rechtsanwalt Christoph Schommer")]),_c('p',[_c('strong',[_vm._v("1")]),_vm._v(". "),_c('strong',[_vm._v("Erhebung personenbezogener Daten bei Besuch unserer Website")])]),_c('p',[_c('strong',[_vm._v("1.1 Allgemein")])]),_c('p',[_vm._v("Bei der bloß informatorischen Nutzung meiner Website, also wenn Sie sich nicht registrieren oder mir anderweitig Informationen über die Website übermitteln, erhalte und erhebe ich nur die personenbezogenen Daten, die Ihr Browser an den hiesigen Server zwangsläufig übermittelt. Wenn Sie meine Website nur betrachten und durchschauen möchten, erhebe ich daher lediglich die folgenden Daten, die technisch erforderlich sind, um Ihnen meine Website anzuzeigen, die Auslieferung der Website an Ihren Rechner zu ermöglichen und die Stabilität und Sicherheit zu gewährleisten:")]),_c('ul',[_c('li',[_vm._v("IP-Adresse")]),_c('li',[_vm._v("Datum und Uhrzeit der Anfrage")]),_c('li',[_vm._v("Zeitzonendifferenz zur Greenwich Mean Time (GMT)")]),_c('li',[_vm._v("Inhalt der Anforderung (konkrete Seite)")]),_c('li',[_vm._v("Zugriffsstatus/HTTP-Statuscode")]),_c('li',[_vm._v("jeweils übertragene Datenmenge")]),_c('li',[_vm._v("Website, von der die Anforderung kommt")]),_c('li',[_vm._v("Browser")]),_c('li',[_vm._v("Betriebssystem und dessen Oberfläche")]),_c('li',[_vm._v("Sprache und Version der Browsersoftware.")])]),_c('p',[_vm._v("Die Rechtsgrundlage der diesbezüglichen Verarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.")]),_c('p',[_vm._v("Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, sobald die jeweilige Sitzung beendet ist.")]),_c('p',[_vm._v("Die Erfassung dieser Daten zur Bereitstellung der Website und die Speicherung der Daten in Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht folglich seitens des Nutzers keine Widerspruchsmöglichkeit.")]),_c('p',[_c('strong',[_vm._v("1.2 Cookies")])]),_c('p',[_vm._v("Zusätzlich zu den zuvor genannten Daten werden bei Ihrer Nutzung meiner Website Cookies auf Ihrem Rechner gespeichert. Bei Cookies handelt es sich um kleine Textdateien, die auf Ihrer Festplatte dem von Ihnen verwendeten Browser zugeordnet gespeichert werden und durch welche der Stelle, die den Cookie setzt (hier durch mein Website), bestimmte Informationen zufließen. Cookies können keine Programme ausführen oder Viren auf Ihren Computer übertragen. Sie dienen dem Zweck, das Internetangebot insgesamt nutzerfreundlicher und effektiver zu machen. Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies ist Art. 6 Abs. 1 lit. f DSGVO.")]),_c('p',[_c('strong',[_vm._v("1.3 Einsatz von Cookies")])]),_c('p',[_vm._v("Diese Website nutzt ausschließlich transiente Cookies")]),_c('p',[_vm._v("Umfang und Funktionsweise:"),_c('br'),_vm._v("Transiente Cookies werden automatisiert gelöscht, wenn Sie den Browser schließen. Dazu zählen insbesondere die Session-Cookies. Diese speichern eine sogenannte Session-ID, mit welcher sich verschiedene Anfragen Ihres Browsers der gemeinsamen Sitzung zuordnen lassen. Dadurch kann Ihr Rechner wiedererkannt werden, wenn Sie auf meine Website zurückkehren. Die Session-Cookies werden gelöscht, wenn Sie sich ausloggen oder den Browser schließen.")]),_c('p',[_vm._v("Sie können Ihre Browser-Einstellung entsprechend Ihren Wünschen konfigurieren und z. B. die Annahme von Third-Party-Cookies oder allen Cookies ablehnen. Ich weise jedoch darauf hin, dass Sie in diesem Fall eventuell nicht alle Funktionen dieser Website nutzen können.")]),_c('p',[_c('strong',[_vm._v("1.4 Widerspruchs- und Beseitigungsmöglichkeit für alle Dienste, die Cookies nutzen")])]),_c('p',[_vm._v("Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an meine Seite übermittelt. Daher haben Sie auch die volle Kontrolle über die Verwendung von Cookies. Sie können durch eine Änderung der Einstellungen in Ihrem Internetbrowser die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies können Sie jederzeit löschen. Dies kann auch automatisiert erfolgen. Wenn Sie Cookies für meine Website deaktivieren, können Sie möglicherweise nicht mehr alle Funktionen meiner Website vollumfänglich nutzen.")]),_c('p',[_c('strong',[_vm._v("2. E-Mail Kontakt")])]),_c('p',[_vm._v("Eine Kontaktaufnahme mit mir ist außerhalb der Website über meine genannte E-Mail-Adresse möglich. In diesem Fall werden die von Ihnen mit der E-Mail übermittelten personenbezogenen Daten bei mir gespeichert.")]),_c('p',[_vm._v("Bei Ihrer Kontaktaufnahme werden die von Ihnen mitgeteilten Daten von mir ausschließlich zu dem Zweck der Bearbeitung Ihrer Kontaktaufnahme verarbeitet. Es erfolgt im Zusammenhang mit dieser Datenverarbeitung keine Weitergabe der Daten an Dritte.")]),_c('p',[_vm._v("Die Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. f DSGVO. Soweit die Kontaktaufnahme auf den Abschluss eines Vertrages abzielt, ist die zusätzliche Rechtsgrundlage der Verarbeitung Art. 6 Abs. 1 lit. b DSGVO.")]),_c('p',[_vm._v("Die in diesem Zusammenhang anfallenden Daten lösche ich, wenn sie zur Zweckerreichung nicht mehr erforderlich sind.")]),_c('p',[_vm._v("Für die personenbezogenen Daten, die von Ihnen per E-Mail übersandt wurden, ist dies dann der Fall, wenn die jeweilige Konversation beendet ist. Beendet ist die Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der betroffene Sachverhalt abschließend geklärt ist.")]),_c('p',[_vm._v("Wenn Sie mit mir per E-Mail (außerhalb der Website) in Kontakt getreten sind, können Sie einer Speicherung Ihrer personenbezogenen Daten widersprechen. Sie können Ihren Widerspruch an die oben angegebene Stelle richten.")]),_c('p',[_vm._v("Bitte beachten Sie, dass in einem solchen Fall die Konversation nicht fortgeführt werden kann und beendet werden muss. Die im Zuge der Kontaktaufnahme übermittelten und gespeicherten Daten lösche ich dann.")]),_c('p',[_c('strong',[_vm._v("3. Ihre Rechte als betroffene Person")])]),_c('p',[_c('strong',[_vm._v("3.1")]),_vm._v(" Sie haben mir gegenüber die folgenden Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:")]),_c('p',[_c('strong',[_vm._v("Auskunft, Art. 13 Abs. 2 lit. b), Art. 15 DSGVO")])]),_c('p',[_vm._v("Sie haben das Recht, von mir Auskunft über die bei mir über Sie gespeicherten personenbezogenen Daten zu verlangen. Diese Auskunft erteile ich Ihnen nach Ihrer Anfrage. Weiterhin teile ich Ihnen auf Anfrage mit, an welche dritten Stellen gfs. Ihre personenbezogenen Daten übermittelt wurden.")]),_c('p',[_c('strong',[_vm._v("Berichtigung, Art. 13 Abs. 2 lit. b), Art. 16 DSGVO")])]),_c('p',[_vm._v("Sie haben das Recht, von mir zu verlangen, Ihre personenbezogenen Daten zu berichtigen oder zu vervollständigen. Geben Sie mir keinen entsprechenden Hinweis, so erfolgt dies jedenfalls unverzüglich dann, wenn mir bekannt wird, dass die bei mir gespeicherten Daten fehlerhaft oder unvollständig sind.")]),_c('p',[_c('strong',[_vm._v("Löschung, Art. 13 Abs. 2 lit. b), Art. 17 DSGVO")])]),_c('p',[_vm._v("Sie haben das Recht, von mir die Löschung der bei mir gespeicherten personenbezogenen Daten zu verlangen. Die Möglichkeit einer tatsächlichen Löschung richtet sich dabei danach, ob die Erfüllung einer rechtlichen Verpflichtung durch mich, wie etwa die Einhaltung gesetzlicher (steuerlicher) Aufbewahrungspflichten sowie die Geltendmachung, Ausübung und Verteidigung von Rechtsansprüchen dies möglich macht.")]),_c('p',[_vm._v("Grundsätzlich gilt für die Löschung Ihrer Daten, dass dies durch mich dann erfolgt, wenn die Daten für den jeweiligen Zweck (s.o.) nicht mehr erforderlich sind.")]),_c('p',[_c('strong',[_vm._v("Einschränkung der Verarbeitung, Art. 13 Abs. 2 lit. b), Art. 18 DSGVO")])]),_c('p',[_vm._v("Sie haben das Recht, von mir die Einschränkung der Verarbeitung zu verlangen. Dies ist insbesondere dann relevant, wenn einer Löschung Gründe entgegenstehen. Ihre personenbezogenen Daten werden ab diesem Zeitpunkt nur noch mit Ihrer Einwilligung verarbeitet.")]),_c('p',[_c('strong',[_vm._v("Recht auf Datenübertragbarkeit, Art. 13 Abs. 2 lit. b), Art. 20 DSGVO")])]),_c('p',[_vm._v("Sie haben das Recht, von mir eine Übertragung Ihrer personenbezogenen Daten an sich selbst oder Dritte in einem strukturierten, gängigen und maschinenlesbaren Format zu verlangen.")]),_c('p',[_c('strong',[_vm._v("Widerruf der Einwilligung, Art. 13 Abs. 2 lit. c) DSGVO")])]),_c('p',[_vm._v("Soweit Sie eine Einwilligung zur Datenverarbeitung erteilt haben, haben Sie das Recht die mir gegenüber erteilte Einwilligung jederzeit zu widerrufen. Dies berührt jedoch nicht die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung.")]),_c('p',[_c('strong',[_vm._v("3.2")]),_vm._v(" Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.")]),_c('p',[_c('strong',[_vm._v("Aktualität und Änderung dieser Datenschutzerklärung")])]),_c('p',[_vm._v("Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Januar 2019.")]),_c('p',[_vm._v("Durch die Weiterentwicklung meiner Website und Angebote darüber oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit hier auf meiner Website von Ihnen abgerufen und ausgedruckt werden.")]),_c('p',[_vm._v("Wenn Sie Fragen hinsichtlich der Verarbeitung Ihrer persönlichen Daten haben, können Sie sich direkt an meinen bevollmächtigten Vertreter/Beauftragten für den Datenschutz (Herrn Rechtsanwalt Axel Claußen) wenden, der auch im Falle von Auskunftsersuchen, Anträgen oder Beschwerden zur Verfügung steht:")]),_c('p',[_vm._v("E-Mail: "),_c('a',{attrs:{"href":"mailto:sclaussen@ra-claussen.de"}},[_vm._v("claussen@ra-claussen.de")]),_vm._v("  oder über mich: "),_c('a',{attrs:{"href":"mailto:schommer@bln-partner.de"}},[_vm._v("schommer@bln-partner.de")])]),_c('p',[_c('strong',[_vm._v("Urheberrecht")])]),_c('p',[_vm._v("Ich bin beim Betreiben dieser Website sorgfältig bemüht, stets die Urheberrechte anderer zu beachten bzw. auf selbst erstellte sowie lizenzfreie Werke zurückzugreifen.")]),_c('p',[_vm._v("Die erstellten Inhalte und Werke auf den Seiten unterliegen dem deutschen Urheberrecht. Mögliche Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.")]),_c('p',[_c('strong',[_vm._v("Responsibility for Content")])]),_c('p',[_vm._v("As operator of these pages we are responsible for our own content under § 6 I MDStV and § 8 I TDG according to general laws. The contents of these pages are compiled with the greatest care. We do not, however, accept any responsibility for the accuracy, completeness or topicality of the contents.")]),_c('p',[_c('strong',[_vm._v("Responsibility for Links")])]),_c('p',[_vm._v("Our offer includes links to external web sites. We have no influence on these content. Therefore we can not accept any responsibility for the content of these websites. In each case the operators of the linked pages are responsible for their contents. The linked pages were checked for possible legal irregularities at the time of the establishment of the link. A permanent check of the linked pages is not possible without specific indications. If we are told about illegal content, these links will be removed immediately.")]),_c('p',[_c('strong',[_vm._v("Copyright")])]),_c('p',[_vm._v("The published information on these pages are subject to the German Law of Copyright. The reproduction, editing, distribution and any kind of exploitation outside the limits of the copyright law requires the written agreement of the originator. Contents contributed by third parties are marked as such. Downloads and copies of these pages are permitted for private use only. The commercial use of our content without the agreement of the originator is illegal.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sYFj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t/nE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Datenschutz'
});

/***/ }),

/***/ "upN6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home'
});

/***/ }),

/***/ "w8lP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Impressum")]),_c('p',[_vm._v("Hinweise gem. § 6 des Teledienstegesetzes vom 22. Juli 1997 (BGBl. I S. 1870) in der Fassung des Gesetzes über rechtliche Rahmenbedingungen für den elektronischen Geschäftsverkehr (Elektronischer Geschäftsverkehr-Gesetz – EGG) vom 14. Dezember 2001 (BGBl. I S. 3721):")]),_c('p',[_vm._v("Rechtsanwalt Christoph Schommer ist im Bezirk des Landgerichts Berlin als Rechtsanwalt zugelassen.")]),_c('p',[_vm._v("Er ist bei der Allianz Deutschland AG berufshaftpflichtversichert. Die Bezeichnung der Police nenne ich Ihnen gerne in einem persönlichen Gespräch.")]),_c('p',[_vm._v("Sie erreichen mich unter der Anschrift:"),_c('br'),_vm._v("Rechtsanwalt Christoph Schommer"),_c('br'),_vm._v("Albestraße 21"),_c('br'),_vm._v("12159 Berlin"),_c('br'),_vm._v("Telefon: 030 74 75 10 10")]),_c('p',[_vm._v("Rechtsanwalt Christoph Schommer ist Mitglieder der "),_c('strong',[_c('a',{attrs:{"href":"https://www.rak-berlin.de/","target":"_blank"}},[_vm._v("Rechtsanwaltskammer Berlin:")])])]),_c('p',[_vm._v("Rechtsanwaltskammer Berlin"),_c('br'),_vm._v("Littenstr. 9 * 10179 Berlin"),_c('br'),_vm._v("T. (030) 306931-0"),_c('br'),_vm._v("F. (030) 30693199")]),_c('p',[_vm._v("Rechtsanwalt Christoph Schommer unterliegt den berufsrechtlichen Regelungen in den jeweils geltenden Fassungen."),_c('br'),_c('strong',[_c('br'),_vm._v("Berufsrechtliche Regelungen des Rechtsanwalts sind:"),_c('br')]),_vm._v("– "),_c('a',{attrs:{"href":"https://bundesrecht.juris.de/bundesrecht/brao/index.html","target":"_blank"}},[_vm._v("Bundesrechtsanwaltsordnung")]),_vm._v(" (BRAO),"),_c('br'),_vm._v("– "),_c('a',{attrs:{"href":"https://www.rechtsanwaltsgebuehren.de/Berechnen/RAGebBRAGO.html","target":"_blank"}},[_vm._v("Bundesrechtsanwaltsgebührenordnung")]),_vm._v(" (BRAGO; Mandate bis 30.06.2004)"),_c('br'),_vm._v("– "),_c('a',{attrs:{"href":"http://bundesrecht.juris.de/bundesrecht/rvg/index.html","target":"_blank"}},[_vm._v("Rechtsanwaltvergütungsgesetz")]),_vm._v(" (RVG) (Mandate seit 01.07.2004)"),_c('br'),_vm._v("– Berufsordnung der Rechtsanwälte (BORA)"),_c('br'),_vm._v("– Fachanwaltsordnung (FAO)")]),_c('p',[_vm._v("Sie können in die vorgenannten berufsrechtlichen Regelungen auf den Internetseiten der "),_c('a',{attrs:{"href":"https://www.brak.de/seiten/06.php","target":"_blank"}},[_vm._v("Bundesrechtsanwaltskammer")]),_vm._v(" (Stichwort: Berufsrecht), über die Internetseite des "),_c('a',{attrs:{"href":"http://bundesrecht.juris.de/bundesrecht/BMJ_index.html","target":"_blank"}},[_vm._v("Bundesministerium der Justiz")]),_vm._v(" oder über die Seiten der vorgenannten Rechtsanwaltskammer aus Berlin Einsicht nehmen.")]),_c('p',[_vm._v("Verantwortlicher für den Internetauftritt und Datenschutzbeauftragter i.S.d. Bundesdatenschutzgesetzes ist Rechtsanwalt Christoph Schommer sowie für ihn als bevollmächtigter Vertreter Rechtsanwalt Axel Claussen (claussen@ra-claussen.de).")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wR/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('article',[_c('h2',[_vm._v("Allgemeines Zivilrecht")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_page_Header__ = __webpack_require__("RjMa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_page_Footer__ = __webpack_require__("oXpM");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__components_page_Header__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_1__components_page_Footer__["a" /* default */]
  }
});

/***/ }),

/***/ "yMhX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "za8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NeueAdressen'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d848544ff924f6f39c17.js